export default class EventBus {
  constructor() {
    this.emitLastTime = {};
    this.handlers = {};
    this.eventHistories = [];
  }
  initEvent(hash) {
    let keys = Object.keys(hash);
    for (let key of keys) {
      for (let func of hash[key]) {
        this.on(key, func);
      }
    }
  }
  emit(eventName, ...args) {
    this.eventHistories.push(eventName);
    let NOW = new Date();
    let lastTime = this.emitLastTime[eventName] ? this.emitLastTime[eventName] : 0;
    if (NOW - lastTime < 100) {
      return;
    }
    this.emitLastTime[eventName] = NOW;
    var funcs = this.handlers[eventName] || [];
    for (var f of funcs) {
      f(...args);
    }
  }

  on(eventName, cb) {
    this.handlers[eventName] = this.handlers[eventName] ? this.handlers[eventName] : [];
    this.handlers[eventName].push(cb);
  }

  override(eventName, cb) {
    this.handlers[eventName] = [];
    this.handlers[eventName].push(cb);
  }
}